export const Colors = {
  primary: '#3B69B0',
  primaryLight: '#9DCFF3',
  primaryHighlight: '#CDECFB',
  secondary: '#A2C038',
  secondaryLight: '#BCDE44',
  tertiary: '#DC9122',
  tertiaryLight: '#F8BC57',
  grayDark: '#707070',
  grayMid: '#838383',
  gray: '#B0B0AE',
  grayLight: '#ECECEC',
  background: '#F1F5F7',
  white: '#FFFFFF',
  error: '#BE4723',
  errorLight: '#C55A39',
};

const GradientConfig = {
  primary: {
    backgroundColorTop: '#9DCFF3',
    backgroundColorBottom: '#3B69B0',
  },
};
export const Gradients = {
  buttonPrimary: `linear-gradient(to bottom, ${GradientConfig.primary.backgroundColorTop} -100%, ${GradientConfig.primary.backgroundColorBottom} 120%)`,
};
